
import { Hero } from '../components/Hero';
import { SectionSeparator } from '../components/SectionSeparator';
import { Services } from '../components/Services';
import { ImageGallery } from '../components/ImageGallery';
import { SecurityCalculator } from '../components/SecurityCalculator';
import { ProcessSection } from '../components/ProcessSection';
import { AboutSection } from '../components/AboutSection';
import { FAQ } from '../components/FAQ';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { RequestWizard } from '../components/RequestWizard';

export const Home = ({ isWizardOpen, openWizard, closeWizard }) => {

    return (
        <>
            <main>
                {/* Hero Section - First interaction */}
                <Hero onOpenWizard={openWizard} />

                {/* Visual Separator */}
                <SectionSeparator />

                {/* Services Section - with clickable cards */}
                <Services onOpenWizard={openWizard} />

                {/* Turn Image Gallery - Visual impressions */}
                <ImageGallery />

                {/* Anfrage Konfigurator */}
                <SecurityCalculator />

                {/* Process Section - How we work */}
                <ProcessSection onOpenWizard={openWizard} />

                {/* About Us */}
                <AboutSection />

                {/* FAQ */}
                <FAQ />
            </main>

            {/* Floating WhatsApp Button */}
            <WhatsAppButton />

            {/* Request Wizard Modal */}
            <RequestWizard isOpen={isWizardOpen} onClose={closeWizard} />
        </>
    );
};
